 <template>
    <v-container fluid>   
        <v-card>
          <v-toolbar>
            <v-icon>dynamic_feed</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Desgravación Impositiva</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>

          <v-progress-linear v-if="loading" indeterminate size="16"> </v-progress-linear>

          <v-card-text>
              <!-- <v-row dense>
                  
                </v-row>   -->
            <v-row align="center">
              <v-row align="center">
                <v-col >
                  <v-file-input  
                      v-model="archivoFiltroOperaciones"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo Excel"
                      prepend-icon="mdi-paperclip">
                  </v-file-input>
                </v-col>
                <v-col>
                  <v-btn @click="procesarArchivo()">
                    Consultar
                  </v-btn>
                </v-col>
                <v-col cols="4" lg="3">
                  <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                  item-text="nombre" item-value="id" label="Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
              </v-row>
            </v-row>
            <v-row>
              <v-col>
                <v-alert color="info" dark dense>                  
                  <div>
                    Tener en Cuenta. El archivo debe tener formato Excel, con 2 columnas (Columnas/Encabezados): 
                  </div>
                  <div>
                  A - Credito
                  </div>
                  <div>
                  B - Comentario
                  </div>
                </v-alert>
              </v-col>
            </v-row>
 

            <v-row v-if="this.btnDescargar">
              <v-col cols="2">
                  <v-btn @click="procesarLista()"  color="info">
                    Descargar listado
                  </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="this.btnDescargar">
              <v-col cols="2">
                <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
              </v-col>                       
            </v-row>  
          </v-card-text>

          <v-card-actions>

          </v-card-actions>
        </v-card >

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'


export default {

  data() {
    return {
      loading: false,
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Apellido', value: 'motorApellido', width:80, sortable:false },
        { text: 'Nombre', value: 'motorNombre', width:80, sortable:false },
        { text: 'Cuil', value: 'motorCuil'},
        { text: 'Respuesta', value: 'resultado'},
      ],
      filtro:{empresaId:0},
      records: [], // registros
      listTable: [], //registros tabla
      listTableError: [], //registros que dieron error
      selectedRows: [],
      agruparPorSucursal: true,
      archivoFiltroOperaciones:[],
      listEmpresas: [],
      btnDescargar: false
    };
  },
  async created() {   
      this.loadEmpresas();
  },  
  watch: {    
    //  'filtro.empresaId': function(){        
    //     this.loadCanalesVenta();
  },
  computed: {
    ...mapGetters(['getActionFromLink','user']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["setActiveTask", "setActiveSubTask", "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),

    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;

        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async procesarArchivo(){

        if(this.filtro.empresaId == 0){
            return this.alertWarning('Por favor seleccione una empresa');
        }

        if(this.archivoFiltroOperaciones.length == 0){
            return this.alertWarning('Por favor selecione un archivo excel');
        }

        this.loading = true;

        let request = new FormData(); 

        request.append('archivo',this.archivoFiltroOperaciones);
        request.append('empresaId', this.filtro.empresaId);

        try{

            var result = await http.post('gestion/desgravacionimpositiva', request);

            this.alertSuccess('Los datos se cargaron correctamente');
        }
        catch(err){
            console.error(err);
        }

        this.loading = false;

    },
    async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },
  }
}
</script>


